var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"alert-container",style:({ background: _vm.backdrop ? _vm.backdrop: 'rgba(0, 0, 0, 0.445)' })},[_c('div',{staticClass:"alert-message",class:_vm.theme,style:({
            background: _vm.background ? _vm.background : "",
            color: _vm.messageColor ? _vm.messageColor : "#fff"
        })},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }